import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonComponent } from '@ppl/ui';
import {  ListTableComponent  } from '@ppl/ui';
import { ClaimsService } from '../../../../services/claims.service';
import { LeadDetailsService } from '../../../../services/lead-details.service';
import { ReferralDataService } from '../../../../services/referral-data.service';
import { SectionsService } from '../../../../services/sections.service';
import { AllowListAuthStore } from '../../../../shared/authorization/allow-list-auth.store';
import { SharedDataService } from '../../../../shared/services/shared-data-service';
import { PAGE_CONSTANTS } from '../../../../shared/constants/page.constants';
import { STATIC_DATA } from '../../../../shared/constants/static-data.constants';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'ppl-service-code-list',
  standalone: true,
  imports: [ButtonComponent, ListTableComponent],
  templateUrl: './service-code-list.component.html',
  styleUrl: './service-code-list.component.css',
})
export class ServiceCodeListComponent implements OnInit {
  sharedDataKey: string = STATIC_DATA.SHARED_SERVICE_CODE_DATA;
  pageId: string = PAGE_CONSTANTS.SERVICE_CODE_GRID_PAGE;
  columnsToBeHidden: string[] = [];
  actionsToBeHidden: string[] = [];
  isPageRestrictionLoaded = false;
  isReadOnly = false;
  programName!: string;
  lazyLoad = true;

  constructor(
    private router: Router, private sectionService: SectionsService, private referralDataService: ReferralDataService,
    private leadDetailsService: LeadDetailsService, private sharedDataService: SharedDataService,
    private claimsService: ClaimsService, private userService: UserService,
    private allowListStore: AllowListAuthStore
  ) {
  }

  ngOnInit() {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.setPageAccess();
  }

  onAddServiceCode() {
    this.sectionService.setFlow('serviceCode');
    this.userService.setLeadEntry('serviceCode');
    this.userService.setSelectedId(null);
    this.router.navigate(['/home/serviceCode', 'add']);
  }

  rowClicked(rowDetail: any) {
    const program = this.userService.getSelectedProgram();
    this.userService.setLeadEntry('serviceCode');
    this.sectionService.setFlow('serviceCode');
    this.userService.setSelectedId(rowDetail.serviceCodeDetailId);
      this.claimsService.fetchClaimsData(
          program?.program_code ?? '',
          rowDetail.serviceCodeDetailId,
          'serviceCode'
        )
        .subscribe((data: any) => {
          this.claimsService.setFormData('service_code', data.responsedata);
          setTimeout(() => {
            this.router.navigate(['/home/serviceCode', 'update']);
          }, 200);
        });
  }

  private setPageAccess() {
    const authConfig = this.allowListStore.getConfig();
    if (authConfig && !authConfig.pages[this.pageId]) {
      this.isReadOnly = true;
    }
    this.isPageRestrictionLoaded = true;
  }
}
